document.addEventListener("click", function (event) {
  const toggleButton = event.target.closest(".js.toggle-button");

  if (toggleButton) {
    const toggleContainer = toggleButton.closest(".js.toggle-container");
    toggleContainer.classList.toggle("active");
    const fieldset = toggleContainer.querySelector(".js.product-form__input");

    fieldset.style.display =
      fieldset.style.display === "none" || fieldset.style.display === ""
        ? "flex"
        : "none";

    event.stopPropagation();
  }
});

document.addEventListener("click", function (event) {
  const swatch = event.target.closest(".swatch-input__label");
  if (swatch) {
    const swatchSquare = swatch.querySelector(".swatch");

    if (swatchSquare) {
      const imageUrl = swatchSquare.style
        .getPropertyValue("--swatch--background")
        .replace("url(", "")
        .replace(")", "")
        .replace(/"/g, "")
        .replace("&amp;", "&")
        .split("?")[0];
      

      if (imageUrl && imageUrl.includes('files')) {
        openModal(imageUrl);
      }
    }
  }
});

function openModal(imageUrl) {
  const modal = document.getElementById("imageModal");
  const modalImage = document.getElementById("modalImage");

  if (!modal || !modalImage) {
    console.warn("Modal or image element not found!");
    return;
  }

  modalImage.src = imageUrl;

  setTimeout(() => {
    modal.classList.add("show");
  }, 200);
}

document.addEventListener("click", function (event) {
  const modal = document.getElementById("imageModal");

  if (event.target.classList.contains("swatch-modal-close")) {
    modal.classList.remove("show");
  }
});

function closeModal() {
  const modal = document.getElementById("imageModal");
  if (!modal) return;
  modal.classList.remove("show");
}

window.onclick = function (event) {
  const modal = document.getElementById("imageModal");
  if (event.target === modal) {
    closeModal();
  }
};

